import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { TableCell, TableRow } from '@mui/material';
import ModalForUpdateProduct from './ModalForUpdateProduct';
import { confirmDialog } from '../Reusable/ConfirmDialog';

const ProductRow = ({
  clearValidationErrors,
  dispatch,
  updateProduct,
  updateProductWithLogo,
  findProductByIdWithLogo,
  deleteProduct,
  product,
  productReducer,
  productCategoryReducer,
}) => {
  const [show, setShow] = useState(false);

  const onDeleteClick = (id) => {
    const action = () => {
      dispatch(deleteProduct(id));
    };
    confirmDialog('obrišete proizvod', action, ', obriši!');
  };

  const showModal = (e) => {
    setShow(true);
  };

  const handlePreviewClose = () => {
    setShow(false);
    clearValidationErrors();
  };

  const handleEdit = (product) => {
    dispatch(updateProduct(product, handlePreviewClose));
  };

    const handleEditWithLogo = (product) => {
    dispatch(updateProductWithLogo(product, handlePreviewClose));
  };

  let row = (
    <TableRow>
      <TableCell>{product.productName}</TableCell>
      <TableCell>{product.price}</TableCell>
      <TableCell>{product.description}</TableCell>
      <TableCell>{product.productCategory.productCategoryName}</TableCell>

      <TableCell className="text-center" id="centerRow">
        <Link
          to="#"
          onClick={(e) => {
            showModal();
          }}
        >
          <i className="fas fa-edit fa-2x" />
        </Link>
      </TableCell>

      <TableCell
        className={`text-center ${product.id === 2 && 'disable-events'}`}
      >
        <Link
          to="#"
          id="deleteProduct"
          onClick={() => onDeleteClick(product.id)}
        >
          <i
            className={`fas fa-trash-alt fa-2x ${
              product.id === 2 && 'disable-color'
            }`}
          />
        </Link>
      </TableCell>
    </TableRow>
  );
  return (
    <>
      {row}
      {show && (
        <ModalForUpdateProduct
          show={show}
          product={product}
          productReducer={productReducer}
          productCategoryReducer={productCategoryReducer}
          handleEdit={handleEdit}
          updateProductWithLogo={handleEditWithLogo}  
          findProductByIdWithLogo={findProductByIdWithLogo}        
          handleClose={handlePreviewClose}
          clearValidationErrors={clearValidationErrors}
          productId={product.id}
        />
      )}
    </>
  );
};

export default ProductRow;
